export default __webpack_public_path__ + "static/media/beach-truck.5e1c2549.png";